// product-meta-info.js (lazy loading + requestIdleCallback + soglia modificabile)

const LOAD_THRESHOLD_PERCENT = 65; // <-- Modifica qui la soglia di caricamento
const CHECK_INTERVAL_MS = 400;
const IDLE_TIMEOUT_MS = 1200;

// -------------------- Utility --------------------

function getPageLoadPercent() {
  const [navTiming] = performance.getEntriesByType("navigation");
  if (!navTiming) return 100;

  const totalLoadTime = navTiming.loadEventEnd - navTiming.startTime;
  if (totalLoadTime <= 0) return 100;

  const elapsed = performance.now();
  return Math.min(100, Math.floor((elapsed / totalLoadTime) * 100));
}

function runWhenIdle(fn) {
  if ("requestIdleCallback" in window) {
    requestIdleCallback(fn, { timeout: IDLE_TIMEOUT_MS });
  } else {
    setTimeout(fn, 100);
  }
}

function waitForLoadThreshold(threshold, callback) {
  function checkAndRun() {
    if (getPageLoadPercent() >= threshold) {
      runWhenIdle(callback);
      return true;
    }
    return false;
  }

  function scheduleCheck() {
    if (!checkAndRun()) {
      const interval = setInterval(() => {
        if (checkAndRun()) clearInterval(interval);
      }, CHECK_INTERVAL_MS);
    }
  }

  if (document.readyState === "complete") {
    scheduleCheck();
  } else {
    window.addEventListener("load", scheduleCheck, { once: true });
  }
}

// -------------------- Init --------------------

waitForLoadThreshold(LOAD_THRESHOLD_PERCENT, initProductMetaInfo);

function initProductMetaInfo() {
  updateShippingText();
  updateRate();

  document.addEventListener("variant:change", () => {
    updateShippingText();
    updateRate();
  });

  const observer = new MutationObserver(mutations => {
    for (const { attributeName } of mutations) {
      if (attributeName === "data-price") {
        updateRate();
        break;
      }
    }
  });

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ["data-price"],
  });
}

// -------------------- Helpers --------------------

function getLang() {
  return document.documentElement.lang.startsWith("it") ? "it" : "en";
}

function addBusinessDays(date, days) {
  const result = new Date(date);
  let added = 0;
  while (added < days) {
    result.setDate(result.getDate() + 1);
    const dow = result.getDay();
    if (dow !== 0 && dow !== 6) added++;
  }
  return result;
}

// -------------------- Shipping Text --------------------

function updateShippingText() {
  const headers = document.querySelectorAll(".collapsible[data-days-min]");
  if (!headers.length) return;

  const lang = getLang();
  const formatter = new Intl.DateTimeFormat(lang, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  headers.forEach(header => {
    const min = Number(header.dataset.daysMin) || 0;
    const max = Number(header.dataset.daysMax) || min;

    const today = new Date();
    const dMin = addBusinessDays(today, min);
    const dMax = addBusinessDays(today, max);

    const formattedMin = formatter.format(dMin);
    const formattedMax = formatter.format(dMax);

    const shippingText =
      lang === "it"
        ? `Se ordini oggi lo spediremo fra <strong class="kalam-bold">${formattedMin}</strong> e <strong class="kalam-bold">${formattedMax}</strong>`
  : `If you order today we will ship between <strong class="kalam-bold">${formattedMin}</strong> and <strong class="kalam-bold">${formattedMax}</strong>`;

    const idSuffix = header.id.replace("shipping-header-", "");
    const target = document.getElementById(`shippingText-${idSuffix}`);
    if (target) target.innerHTML = shippingText;
  });
}

// -------------------- Rate --------------------

function updateRate() {
  const lang = getLang();
  const formatter = new Intl.NumberFormat(lang, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const priceList = document.querySelector("price-list");
  const rateSpan = document.getElementById("rateAmount");
  if (!priceList || !rateSpan) return;

  const price = parseFloat(priceList.dataset.price);
  rateSpan.textContent = isNaN(price) ? "N/A" : formatter.format(price / 3);
}